import "./MaintenancePromptComponent.scss";
import template from "./MaintenancePromptComponent.html";
import {IComponentOptions, IOnDestroy, ISCEService} from "angular";
import {ReplaySubject} from "rxjs";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";

export const MaintenancePrompt = "tfMaintenancePrompt";

export function maintenancePrompt(): IComponentOptions {
    return {
        template,
        bindings: {
            bannerMessage: "<"
        },
        controllerAs: "ctrl",
        controller: MaintenanceSystemPromptComponentController
    };
}

export class MaintenanceSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);
    public bannerMessage: string;

    /** @ngInject */
    public constructor(
        private readonly currentUserService: CurrentUserService,
        private readonly $sce: ISCEService
    ) {
        this.currentUserService.current.subscribe(u => this.bannerMessage = this.$sce.trustAsHtml(u.bannerMessage()));
    }
    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
